export enum MeetingRoomType {
  BROADCAST = 'broadcast',
  MEETING = 'meeting',
  COMPANY = 'company',
}
